<template>
    <div class="page__profile" v-if="manager">
        <picture class="page__profile-picture">
            <img v-if="!avatar"
                 class="page__profile-img" src="../../assets/img/default-avatar.jpg"/>
            <img v-else class="page__profile-img" :src="avatar.url" :alt="avatar.name"/>
        </picture>
        <div class="page__profile-content">
            <div class="page__profile-title">
                Your account manager
            </div>
            <div class="page__profile-info">
                {{ manager.name }}<br>
                <a href="#" title="#">{{ manager.email }}</a><br>
                {{ manager.phone }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      manager: 'companies/accountManager',
    }),
    avatar() {
      if (this.manager && this.manager.avatars && this.manager.avatars.length > 0) {
        return this.manager.avatars[0];
      }
      return null;
    },
  },
};
</script>
